import {Component} from '@angular/core';
import {TrendingCutPage} from "../../pages/trending-cut/trending-cut";
import {Events, NavController, NavParams} from "ionic-angular";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the TrendingCutsListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'trending-cuts-list',
    templateUrl: 'trending-cuts-list.html'
})
export class TrendingCutsListComponent {

    errors: {};
    loading: boolean;
    tuid: string;
    // Setup empty array of objects to have placeholders on page load
    trendingCuts: any = [{}, {}, {}, {}];

    constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        events.subscribe('trendingCuts:refresh', () => {
            this.getTrendingCuts();
        });

        events.subscribe('trendingCuts:favourite+', (trendingCut) => {
            let index = this.trendingCuts.findIndex(cut => cut.id === trendingCut.id);
            this.trendingCuts[index] = trendingCut;
        });

        events.subscribe('trendingCuts:favourite-', (trendingCut) => {
            let index = this.trendingCuts.findIndex(cut => cut.id === trendingCut.id);
            this.trendingCuts[index] = trendingCut;
        });
    }

    ngOnInit() {
        this.tuid = localStorage.getItem('tuid');
        this.getTrendingCuts();
    }

    getTrendingCuts() {
        this.loading = true;

        this.http.get('/trending-cuts')
            .subscribe((trendingCuts: Array<any>) => {

                let trendingCutsWithFavorites = [];
                for (let trendingCut of trendingCuts) {
                    trendingCut.favorite = trendingCut.user_ids.includes(parseInt(this.tuid));
                    trendingCutsWithFavorites.push(trendingCut);
                }

                this.trendingCuts = trendingCutsWithFavorites;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            })
    }

    openPage(event: any, trendingCut: object) {
        this.navCtrl.push(TrendingCutPage, {
            trendingCut: trendingCut,
            trendingCuts: this.trendingCuts
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/trending-cuts-list/trending-cuts-list.ts